/**
 * Created by jonas on 2020-03-18.
 */
import {
    GameIntroColors,
    GameIntroViewConfig,
    StampConfig,
    Volatility
} from "@nolimitcity/slot-launcher/bin/plugins/concreteplugins/nolimitgameintro/GameIntroView";
import {ImgLoader} from "@nolimitcity/slot-launcher/bin/loader/ImgLoader";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {SlideShowPage} from "@nolimitcity/slot-launcher/bin/gui/views/slideshow/SlideShowPage";
import {ScreenBounds} from "@nolimitcity/slot-launcher/bin/display/ScreenBounds";
import {DjPsycho} from "../DjPsycho";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";

export class DjPsychoIntroConfig implements GameIntroViewConfig {

    colors: GameIntroColors = {
        slideShowColors: {
            backgroundColor: 0x000000, //Default 0x000000
            backgroundAlpha: 0.4, //Default 0.4
            bulletColor: 0xffffff //Default 0xffffff
        },
        stampColor: 0xFFFFFF
    };

    stampConfig: StampConfig = {
        snowflake: true,
        xBet: true,
        xCluster: true,
        volatility: Volatility.MEDIUM
    };

    background: PIXI.Container;
    borderBottom: PIXI.Container;
    borderTop: PIXI.Container;
    logo: PIXI.Container;
    pages: SlideShowPage[];
    private _logoSprite: PIXI.Sprite;

    public init(): Promise<GameIntroViewConfig> {
        const imgLoader: ImgLoader = new ImgLoader(NolimitApplication.resourcePath);
        imgLoader.add("introBg", "resources/images/Intro_BG.jpg");
        imgLoader.add("introDiv", "resources/images/Intro_Divider.png");
        imgLoader.add("feature1", "resources/images/intro_feature1.png");
        imgLoader.add("feature2", "resources/images/intro_feature2.png");
        imgLoader.add("feature3", "resources/images/intro_feature3.png");
        imgLoader.add("feature4", "resources/images/intro_feature4.png");
        imgLoader.add("logo", "resources/images/Logo_Main.png");

        return imgLoader.load().then(() => {
            this.initGraphics();
            return this;
        });
    }

    public onResize(): void {
        const bounds: ScreenBounds = NolimitApplication.screenBounds;
        this._logoSprite.visible = true;
        if (NolimitApplication.isLandscape) {
            this._logoSprite.position.set(-495, 50);
            this._logoSprite.scale.set(.7);
            if (bounds.width <= 970) {
                this._logoSprite.visible = false;
            }
        } else {
            this._logoSprite.position.set(0, -150);
            this._logoSprite.scale.set(1);
            if (bounds.height <= 970) {
                this._logoSprite.position.set(0, -80);
                this._logoSprite.scale.set(0.7);
            }
        }
    }

    private initGraphics(): void {
        this.background = new PIXI.Container();
        const bgSprite: PIXI.Sprite = new PIXI.Sprite(ImgLoader.getImgTexture("introBg"));
        bgSprite.anchor.set(0.5);
        this.background.addChild(bgSprite);

        this.borderTop = new PIXI.Container();
        const topSprite: PIXI.Sprite = new PIXI.Sprite(ImgLoader.getImgTexture("introDiv"));
        topSprite.anchor.set(0.5);
        this.borderTop.addChild(topSprite);

        this.borderBottom = new PIXI.Container();
        const bottomSprite: PIXI.Sprite = new PIXI.Sprite(ImgLoader.getImgTexture("introDiv"));
        bottomSprite.rotation = Math.PI;
        bottomSprite.anchor.set(0.5);
        this.borderBottom.addChild(bottomSprite);

        this.logo = new PIXI.Container();
        this._logoSprite = new PIXI.Sprite(ImgLoader.getImgTexture("logo"));
        this._logoSprite.anchor.set(0.5);
        this.logo.addChild(this._logoSprite);

        this.pages = [
            new SlideShowPage(ImgLoader.getImgTexture("feature1")),
            new SlideShowPage(ImgLoader.getImgTexture("feature2")),
        ];

        if (DjPsycho.apiPlugin.gameClientConfiguration.isSet) {
            this.handleConditionalPages();
        } else {
            DjPsycho.apiPlugin.events.once(APIEvent.GAME_CLIENT_CONFIGURATION_APPLIED, () => {
                this.handleConditionalPages();
            });
        }

        this.pages.forEach((page: SlideShowPage) => {
            (page.children[0] as PIXI.Sprite).anchor.set(0.5);
        });

        this.onResize();
    }

    private handleConditionalPages(): void {
        if (DjPsycho.apiPlugin.gameClientConfiguration.boostedBetAllowed) {
            this.addBoostPage();
        }

        if (DjPsycho.apiPlugin.gameClientConfiguration.showSimulatedMaximumPayout) {
            this.addWinCapPage();
        }
    }

    private addBoostPage(): void {
        const page: SlideShowPage = new SlideShowPage(),
            betBoostImage: PIXI.Sprite = new PIXI.Sprite(ImgLoader.getImgTexture("feature3"));

        betBoostImage.anchor.set(0.5);
        page.addChild(betBoostImage)
        this.pages.push(page);
    }

    private addWinCapPage(): void {
        const page: SlideShowPage = new SlideShowPage(),
            winCapImage: PIXI.Sprite = new PIXI.Sprite(ImgLoader.getImgTexture("feature4"));

        winCapImage.anchor.set(0.5);
        page.addChild(winCapImage);
        this.pages.push(page);
    }
}
